import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TourActions } from '@state/slices/tours/tourActions';

export interface TourFiltersState {
  airport: string | null;
  adults: number | null;
}

export const INITIAL_TOUR_FILTERS_STATE: TourFiltersState = {
  airport: null,
  adults: null
};

const tourFiltersSlice = createSlice({
  name: TourActions.SLICE_NAME,
  initialState: INITIAL_TOUR_FILTERS_STATE,
  reducers: {
    setTourFilters: (state: TourFiltersState, action: PayloadAction<TourFiltersState>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    },
    unsetTourFilters: () => {
      return INITIAL_TOUR_FILTERS_STATE;
    }
  }
});

export const { setTourFilters, unsetTourFilters } = tourFiltersSlice.actions;

export const tourFiltersReducer = tourFiltersSlice.reducer;
